import { CircleHelp } from 'lucide-react';
import { DisclosureTooltip } from '../DisclosureTooltip/DisclosureTooltip';
import { StarRating } from './StarRating';

export interface BigNumberLayoutProps {
  starRating?: number;
  starRatingTooltip?: string;
}

/**
 * Tailwind port of legacy `BigNumberLayout` (review heading hero rating).
 * Horizontal score + label/tooltip + star row; no /5 suffix or review link.
 */
export function BigNumberLayout({ starRating, starRatingTooltip }: BigNumberLayoutProps) {
  if (!starRating) {
    return null;
  }

  return (
    <div className="flex items-center">
      <span className="typography-review-rating mr-1 inline-block">{starRating.toFixed(1)}</span>
      <div className="flex flex-col justify-center">
        <div className="inline-flex items-center whitespace-nowrap">
          <span className="typography-text-small text-muted-foreground">NerdWallet rating </span>
          {starRatingTooltip ? (
            <DisclosureTooltip
              trigger={
                <button
                  aria-label="NerdWallet rating info"
                  className="typography-text-small inline-flex cursor-pointer bg-transparent p-0 align-middle text-foreground"
                  type="button"
                >
                  <CircleHelp aria-hidden size="0.813rem" />
                </button>
              }
            >
              <span className="typography-text-small text-foreground">{starRatingTooltip}</span>
            </DisclosureTooltip>
          ) : null}
        </div>
        <StarRating className="mt-px mr-[5px]" gap="6px" size="19px" value={starRating} />
      </div>
    </div>
  );
}
